import createApi from './createApi';
import Restful from './Restful';
/**
 * @param {?object} config
 * @param {?object} interceptors
 */

function createRestfulApi(config, interceptors) {
  return createApi(config, interceptors)(Restful);
}

export default createRestfulApi;